import { render, staticRenderFns } from "./QuestionCreateTranslation.vue?vue&type=template&id=510896fb&"
import script from "./QuestionCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./QuestionCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports